import { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

export const useQueryParams = () => {
  const location = useLocation();
  const history = useHistory();
  const [queryString, setQueryString] = useState<string>(location.search);

  const getQueryParams = (queryString: string): Record<string, string[]> => {
    const queryParams: Record<string, string[]> = {};
    const searchParams = new URLSearchParams(queryString);

    searchParams.forEach((value, key) => {
      queryParams[key] = value.includes(',') ? value.split(',') : [value];
    });

    return queryParams;
  };

  const setQueryParams = (
    updates: Record<string, string | string[] | null>
  ) => {
    const searchParams = new URLSearchParams(location.search);

    Object.entries(updates).forEach(([key, value]) => {
      if (value === null || value === undefined || value === '') {
        searchParams.delete(key);
      } else if (Array.isArray(value)) {
        value = value.filter((v) => v !== null && v !== undefined && v !== '');
        if (value.length === 0) {
          searchParams.delete(key);
        } else {
          searchParams.set(key, value.join(','));
        }
      } else {
        searchParams.set(key, value);
      }
    });

    const updatedQueryString = `?${searchParams.toString()}`;
    history.replace({ search: updatedQueryString });
    setQueryString(updatedQueryString);
  };

  useEffect(() => {
    setQueryString(location.search);
  }, [location.search]);

  return {
    queryString,
    queryParams: getQueryParams(queryString),
    setQueryParams,
  };
};
